import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes, restrictedRoutes } from ".";
import NotFoundPage from "../pages/notfound/NotFoundPage";

function RenderRoute() {
  return (
    <Routes>
      {/* public route */}
      {publicRoutes.map((route) => {
        return (
          <Route
            key={route.id}
            path={route.path}
            element={<route.component />}
          ></Route>
        );
      })}
      {/* restricted route */}
      {restrictedRoutes.map((route) => {
        return (
          <Route
            key={route.id}
            path={route.path}
            element={<route.component />}
          ></Route>
        );
      })}
      {/* private route */}
      {privateRoutes.map((route) => {
        return (
          <Route
            key={route.id}
            path={route.path}
            element={<route.component />}
          ></Route>
        );
      })}
      <Route path="/" element={<Navigate to="/list/cr_thuoc" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default RenderRoute;
